import { Typography } from 'antd';
import { useField } from 'formik';
import { getEffectiveUnitPrice } from 'utils/InvoiceUtils';
import { getIrelandTaxCodePercents } from 'store/invoice-config/types';
import { AppliedAdditionalCharge } from 'store/invoices/types';

type Props = {
    index: number;
    dataTestId: string;
    liabilityGross: number;
};

const TaxAmountCell = ({ index, dataTestId, liabilityGross }: Props) => {
    const [field] = useField<AppliedAdditionalCharge>(`additionalCharges.${index}`);
    const charge = field.value;
    const netAmount = getEffectiveUnitPrice(charge, liabilityGross) * (charge.quantity ?? 1);
    const rate = getIrelandTaxCodePercents(charge.taxCode) / 100;
    const taxAmount = rate * netAmount;
    return <Typography.Text data-testid={dataTestId}>{taxAmount.toFixed(2)}</Typography.Text>;
};

export default TaxAmountCell;
